export interface DataEntity_Main_10_Interface {
    id: number,
    calibration_id: number,
    filename: string,

    pdf_src: string,

    manufacture: string,
    model: string,
    type: string,

    before: number,

    unit_nominal: string,
    unit_error: string,
    


    ////Mohit
    temperature_Air_before: string,
    temperature_Air_after: string,

    humidity_Air_before: string,
    humidity_Air_after: string,

    pressure_before: string,
    pressure_after: string,

}

export function Empty_DataEntity_Main_10_Interface(): DataEntity_Main_10_Interface {
    return {
        id: 0,
        calibration_id: 0,
        filename: '',

        pdf_src: '',

        manufacture: '',
        model: '',
        type: '',


        unit_nominal: '',
        unit_error: '',
        before: 0,


        ////Mohit


        temperature_Air_before: '',
        temperature_Air_after: '',

        humidity_Air_before: '',
        humidity_Air_after: '',

        pressure_before: '',
        pressure_after: '',


    }
}
